import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, Input, NgZone, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { take } from 'rxjs';
import { ConnectionService } from 'src/app/services/connection.service';
import { EbayService } from 'src/app/services/ebay.service';
import { TemplateService } from 'src/app/services/template.service';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { InventoryService } from '../../services/inventory.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { MediaService } from '../../services/media.service';
import { Media, MediaType } from '@contracts/interfaces/media.interfaces';

@Component({
  selector: 'app-item-ebay',
  templateUrl: './item-ebay.component.html',
  styleUrls: ['./item-ebay.component.scss', './item-ebay-images.component.scss', '../item-features/item-features.component.scss']
})
export class ItemEbayComponent {
  public Editor = ClassicEditor;

  public isLoading = true;
  public panelOpenState = false;

  public mediaAddress: string = "";
  public mediaPath: string = "";
  public ticker = 0;

  public MediaType = MediaType;

  @Input() 
  public item: InventoryItem;

  @Input()
  public data: any;

  itemConditions: any[] = [];

  constructor(
    private _ngZone: NgZone,
    private inventoryService: InventoryService,
    private templateService: TemplateService,
    private ebayService: EbayService,
    private connectionService: ConnectionService,
    private mediaService: MediaService
  ) { }

  ngOnInit(): void { 
    // Public address
    let publicAddress = "https://server.g72.com.au";
    this.mediaPath = publicAddress + "/inventory/" + this.item.number + "/";

    this.inventoryService.itemUpdatedEvent.subscribe(item => {
      //this.reloadDynamic();
    })

    this.categoryChange(+this.item.ebay.PrimaryCategory.CategoryID);

    this.isLoading = false;
  }

  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1)).subscribe(() => this.autosize.resizeToFitContent(true));
  }

  save() {
    this.item.lastModified = new Date();
    this.inventoryService.updateOne(this.item).subscribe(r => { });
  }

  isListed() {
    if (this.item.ebay.ItemID != 0) {
      return true;
    } else {
      return false;
    }
  }

  descriptionOnBlur({ editor }: ChangeEvent) {
    const data = editor.getData();

    this.item.ebay.Description = data;

    this.save();
  }

  addFeature() {
    if (this.item.ebay.ItemSpecifics.NameValueList == undefined) {
      this.item.ebay.ItemSpecifics.NameValueList = [];
    }

    this.item.ebay.ItemSpecifics.NameValueList.push({
      name: "",
      value: ""
    });
  }

  deleteFeature(index: number) {
      this.item.ebay.ItemSpecifics.NameValueList.splice(index, 1);
      this.save();
  }

  //
  trackProgress = 0;
  waitTillSave() {
    this.trackProgress++;

    if (this.trackProgress >= 2) {
      console.log(this.item.ebay);
      this.save();
      this.trackProgress = 0;
    }
  }

  reloadDynamic() {
    this.trackProgress = 0;

    this.item.ebay.PrimaryCategory.CategoryID = this.data.category;
    this.item.ebay.ConditionID = this.data.condition;

    // if (this.item.sell.price != undefined) {
    //   this.item.ebay.StartPrice = this.item.sell.price / 100;
    // }

    this.templateService.render(this.data.title, this.item).subscribe((r: any)=> {
      this.item.ebay.Title = r.render;

      this.waitTillSave();
    });

    this.templateService.render(this.data.description, this.item).subscribe((r: any)=> {
      this.item.ebay.Description = r.render;
      this.waitTillSave();
    });

    this.item.ebay.ItemSpecifics.NameValueList = [];

    if (this.data.aspects != undefined) {
      for (let aspect of this.data.aspects) {
        this.templateService.render(aspect.value, this.item).subscribe((r: any)=>{

          this.item.ebay.ItemSpecifics.NameValueList.push({
            name: aspect.label,
            value: r.render
          });

          this.waitTillSave();
        });
      }
    }

    this.item.ebayImages = [];

    for (let media of this.item.media) {
      this.mediaService.getType(media).subscribe((type: MediaType) => {
        if (type == MediaType.IMAGE) {
          this.item.ebayImages.push(media);
        }
      });
    }
    
    this.prefillImages();

    console.log(this.item)
  }

  prefillImages () {
    const imageMods = "?width=1600&height=1600&fit=cover&background=white";

    this.item.ebay.PictureDetails.PictureURL = [];

    for (let media of this.item.ebayImages) {
      this.item.ebay.PictureDetails.PictureURL.push(
        encodeURI(this.mediaPath + media.filename + imageMods)
      );
    }
  }

  public listingStatus = null;
  public critical: string[] = [];
  public warning: string[] = [];
  listItem() {

    // Prevent submitting listing twice
    if (this.listingStatus == 'Listing...') {
      return;
    }

    this.listingStatus = "Listing...";

    // Ensure ebay SKU is set
    this.item.ebay.SKU = this.item.number;

    this.ebayService.listItem(this.item.ebay).subscribe((r: any) => {
      this.item.ebay.ItemID = r.response.ItemID;
      this.listingStatus = null;

      this.save();
    }, (response: any) => {
      this.listingStatus = "Listing Error";

      let errors = response.error.error.meta.Errors;

      this.critical = [];
      this.warning = [];
      for (let error of errors) {
        if (error.SeverityCode == "Error") {
          this.critical.push(error.ShortMessage);
        } else if (error.SeverityCode == "Warning") {
          this.warning.push(error.ShortMessage);
        }
      }
    });
  }

  categoryChange(category: any) {

    // Get the Item Conditions for this category
    this.ebayService.getConditionIDsForCategory(+category).subscribe((r: any)=> {
      this.itemConditions = r.response;
    })
  }

  reviseFixedPriceItem() {
    this.listingStatus = "Revising Listing...";
    this.ebayService.reviseItem(this.item.ebay).subscribe((r: any) => {
      this.listingStatus = null;

      //this.save();
    })
  }

  removeItem() {
    this.listingStatus = "Removing item...";

    this.ebayService.removeItem(this.item.ebay).subscribe(r => {
      this.item.ebay.ItemID = 0;
      this.save();
      this.listingStatus = "";
    },
    error => {
      console.log(error)
      if (
        // "This item cannot be accessed because the listing has been deleted or you are not the seller."
        error.error.error.meta.Errors.ErrorCode == 17 ||
        // The auction has already been closed.
        error.error.error.meta.Errors.ErrorCode == 1047
      ) {
        this.item.ebay.ItemID = 0;
        this.save();
        this.listingStatus = "";
      }
    });
  }

  removeImage(index: number) {
    this.item.ebayImages.splice(index, 1);

    this.prefillImages();
  }

  shiftImageLeft(index: number) {
    if (index > 0) {
      moveItemInArray(this.item.ebayImages, index, index-1);
      this.prefillImages();
      this.save();
    }
  }

  shiftImageRight(index: number) {
    if (index < this.item.ebayImages.length-1) {
      moveItemInArray(this.item.ebayImages, index, index+1);
      this.save();
    }
  }

  getImageUrl(media: Media) {
    return "url('" + this.mediaPath + media.filename + "?ticker=" + this.ticker + "&width=195&height=190&fit=cover&background=rgb(70,70,70)')";
  }

  enableBestOffer() {
    this.item.ebay.BestOfferDetails.BestOfferEnabled = true;
    if (this.item.ebay.StartPrice > 15) {
      this.item.ebay.ListingDetails.MinimumBestOfferPrice = 15;
    } else {
      this.item.ebay.ListingDetails.MinimumBestOfferPrice = 0;
    }

    if (this.item.ebay.StartPrice > 0) {
      this.item.ebay.ListingDetails.BestOfferAutoAcceptPrice = this.item.ebay.StartPrice - 1;
    } else {
      this.item.ebay.ListingDetails.BestOfferAutoAcceptPrice = null;
    }

    this.save();
  }

  disableBestOffer() {
    this.item.ebay.BestOfferDetails.BestOfferEnabled = false;
    this.save();
  }

  bestOfferMinChange(value: number | null) {
    // Cannot be higher than price
    // Cannot be higher than BestOfferAutoAccept
  }

  bestOfferAutoAcceptChange(value: number | null) {
    // Cannot be higher than price or exactly to
    // Cannot be lower than BestOfferMinimum Price

    console.log(value);
  }

  editImage(media: Media, index: number) {
    this.mediaService.edit(media, (r) => {

    }, {
      list: this.item.ebayImages,
      index: index
    })
  }

  checkListing() {
    this.ebayService.getItemStatus(this.item.ebay.ItemID).subscribe(r=> {
      
    })
  }
}